
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[commercialService]",
      function () {
        return require("private-next-pages/[commercialService].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[commercialService]"])
      });
    }
  